import * as React from "react";
import "./App.css";
import { Route, Routes, useLocation } from "react-router-dom";
import { NavBar } from "./components/ui/navbar/Navbar";
import Admin from "./components/pages/Admin";
import Approvals from "./components/pages/Approvals";
import Dashboard from "./components/pages/Dashboard";
import Providers from "./components/pages/Providers";
import Requestors from "./components/pages/Requestors";
import Services from "./components/pages/Services";
import Login from "./components/pages/Home";
import MarketingHome from "./components/marketing/pages/Home";
import PrivacyPolicy from "./components/pages/PrivacyPolicy";
import DeleteAccount from "./components/pages/DeleteAccount";

export default function EAOneApp() {
  const location = useLocation();
  const hideNavOnRoutes = ["/", "/login", "/policy", "/delete-account"];

  return (
    <div className='eaOneApp'>
      {!hideNavOnRoutes.includes(location.pathname) && <NavBar />}
      <Routes>
        <Route path='/' element={<MarketingHome />} />
        <Route path='/login' element={<Login />} />
        <Route path='/policy' element={<PrivacyPolicy />} />
        <Route path='/delete-account' element={<DeleteAccount />} />
        <Route path='/dashboard' element={<Dashboard />} />
        <Route path='/approvals' element={<Approvals />} />
        <Route path='/requestors' element={<Requestors />} />
        <Route path='/services' element={<Services />} />
        <Route path='/providers' element={<Providers />} />
        <Route path='/admin' element={<Admin />} />
      </Routes>
    </div>
  );
}
